module.exports = "img {\r\n  max-width: 100%;\r\n}\r\n"